import { useTranslation } from 'react-i18next';

import { Card, Text } from '@ngsos/portal-ui';

import '../bootstrapJs';
import { SUPPORTED_CULTURES } from './supportedCultures';

const USER_PREFERRED_CULTURE_KEY = 'UserPrefferedCulture';

const LIFT_OPEN_DROPDOWN_ABOVE_NEXT_CARD = 1;

export type LanguageSelectorProps = {
  title?: string;
  placeholder?: string;
  onSelect?: (culture: string) => void;
};

function changeAppLanguage(selectedLanguage: string) {
  window.localStorage.setItem(USER_PREFERRED_CULTURE_KEY, JSON.stringify(selectedLanguage));
  window.location.reload();
}

export function LanguageSelector({ title, placeholder, onSelect = changeAppLanguage }: LanguageSelectorProps) {
  const { t } = useTranslation();

  return (
    <Card style={{ zIndex: LIFT_OPEN_DROPDOWN_ABOVE_NEXT_CARD }}>
      <div className="d-flex justify-content-between align-items-center gap-3">
        <Text variant="title" role="heading" aria-level={3}>
          {title ?? t('Settings_Title_AppLanguage')}
        </Text>

        <div className="dropdown">
          <button
            className="dropdown-toggle btn btn-outline-primary"
            type="button"
            id="languageDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {placeholder ?? t('Global_LanguageSelector_PlaceHolder')}
            <i className="far fa-xs fa-chevron-down"></i>
          </button>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
            {SUPPORTED_CULTURES.map((culture) => (
              <li key={culture.key}>
                <button type="button" className="dropdown-item" onClick={() => onSelect(culture.key)}>
                  {t(culture.textKey, culture.fallback)}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
}
